export default __webpack_public_path__ + "static/media/PenguinSmart.3971ad8b.png";